import React, { useState, useEffect, useContext } from 'react';
import ReactApexChart from 'react-apexcharts';
import { baseFileURL } from '../../../Api';
import { useCar } from '../../../hooks/useCar';
import { useUpdateEffect } from '../../../hooks/useUpdateEffect';
import { AppContext } from '../../../providers/appProvider';
import { useTranslation } from 'react-i18next';

function MonthYearsChart({ defaultData }) {
        const { t } = useTranslation();
    
    const { appState, app } = useContext(AppContext);
    const  sellers = appState.salers
    const currentYear = new Date().getFullYear();
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedSellerId, setSelectedSellerId] = useState(0);
    const [data, setData] = useState(defaultData);
    const { carService } = useCar(-1);
 

    useUpdateEffect(() => {
        carService.statByYear(selectedYear, selectedSellerId).then(setData).catch((error) => {
            console.error("Failed to fetch data:", error);
        });
    }, [selectedYear, selectedSellerId]);
    

     if (!data || !Array.isArray(data.months) ) {
        return <div>No sales data available</div>;
    } 
 
    let primaryColor = "#000";
    if (baseFileURL === 'https://finance.automoby.ge') {
        primaryColor = "#235e82";
    } else if (baseFileURL === 'https://crm.aig.com.ge') {
        primaryColor = "#da0429";
    }

     const options = {
        chart: {
            type: 'bar',
            height: 350,
            animations: {
                enabled: false
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                borderRadius: 5,
                endingShape: 'rounded'
            },
        },
        title: {
            text: t('Salesbymonth') ,
        },
        colors: [primaryColor],  
        dataLabels: {
            enabled: true,
            position: 'top',
            style: {
                fontSize: '16px',
                colors: ['#FFF']
            },
            formatter: function (val) {
                return val;
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: [primaryColor]
        },
        xaxis: {
            categories: data.months.map(item => `${item.MonthName}`),
        },
        yaxis: {
            title: {
                text:  t('NumberOfCars')
            },
        },
        fill: {
            opacity: 1
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " " + t('Cars');
                }
            }
        },
        theme: {
            monochrome: {
                enabled: true,
                color: primaryColor,
                shadeIntensity: 0.6
            }
        }
    };

    // Series data
    const series = [{
        name: t('Sales'),
        // data: data.months.map(item => item.NumberOfPurchases)
        data: data.months.map(item => 
            typeof item.NumberOfPurchases !== 'undefined' ? item.NumberOfPurchases : 0 // Replace 0 with any default value you prefer
        )
    
    }];

    return (
        <>
            <div style={{ "display": "flex", gap: '10px' }}>
                <select style={{
                    "backgroundColor": "#fff",
                    "color": "var(--secondary-text-color)",
                    "fontWeight": "500",
                    "borderRadius": "5px",
                    "width": "65px",
                    "height": "30px",
                    "border": "1px solid",
                    "borderColor": "var(--border-color)",
                    "textAlign": "center"
                }} value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
                    {Array.from({ length: currentYear - 2022 + 1 }, (_, i) => 2022 + i).map(year => (
                        <option key={year} value={year}>
                            {year}
                        </option>
                    ))}
                </select>

                <select onChange={(e) => setSelectedSellerId(e.target.value)} style={{
                    "backgroundColor": "#fff",
                    "color": "var(--secondary-text-color)",
                    "fontWeight": "500",
                    "borderRadius": "5px",
                    "width": "200px",
                    "height": "30px",
                    "border": "1px solid",
                    "borderColor": "var(--border-color)",
                    "textAlign": "center"
                }}>

                    <option key={0} value={0}>{t('All')}</option>
                    {sellers.map(seller => (
                        <option key={seller.id} value={seller.id}>
                            {seller.firstname} {seller.lastname}
                        </option>
                    ))}
                </select>
            </div>
            
            <ReactApexChart options={options} series={series} type="bar" height={350} />
        </>
    );
}

export default MonthYearsChart;